import $ from 'jquery';

// Header ---
let isExpanded = false;
$('.menyBtn').click(function() {
  // Check if open or not
  if (!isExpanded) {
    $('#mainmenu > div > #mobileTopMenu').css('display', 'block');
    $('#mobileTopMenu > div').css('display', 'block');
    $('#mainmenu > div').css('display', 'block');

    $('#mainmenu').slideToggle({
       duration: 'fast', progress: () => {
        $('.header').css('height', $('.site-navigation').outerHeight());
       }
    });
  } else {

    if ($(window).width() < 576) {
      $('#mainmenu').slideToggle({
        duration: 'fast', progress: () => {
          $('.header').css('height', $('.site-navigation').outerHeight());
        }
      });

      $('.header').css('height', '54px');
    } else {
      $('#mainmenu').slideToggle({
        duration: 'fast', progress: () => {
          $('.header').css('height', $('.site-navigation').outerHeight());
        }
      });

      $('.header').css('height', '64px');
    }


  }

  // Toggle
  isExpanded = !isExpanded;
});

// Contact btn
$('#btnContact').click(() => {
  window.location.href = '/kontakt';
});


// Setting height of admin toolbar since it's bugged
var adminMenu = document.querySelector('.adminimal-admin-toolbar');
if(adminMenu) {
  setTimeout(function() {
      adminMenu.setAttribute("style", "padding-top: 79px");
  }, 250);
}

// Login shortcut
let l = '';
$(document).on('keydown', ({ key }) => {
  if(key === 'q') {
    l += key;
    if(l === 'qqqq') {
      window.location.href = '/user/login';
    }
  }

  if (key == 'Escape') {
    $('.form-open').removeClass('form-open')
    $('#magnifyingGlass').toggle();
    $('#closeX').toggle();
  }

  setTimeout(() => {
    l = '';
  }, 500);
});

$('#btnSearch').on('click', function(e) {
  let searchForm = $('.header-search-form');
  let searchInput = $('.search-input');

  if (searchForm.hasClass('form-open')) {
    searchForm.removeClass('form-open')
  } else {
    searchForm.addClass('form-open')
    setTimeout(function(){
      searchInput.focus()
    }, 200)

  }
  $('#magnifyingGlass').toggle()
  $('#closeX').toggle()
});

$(document).ready(() => {
  let headerSearch = $('.header-search-form').find('form')
  headerSearch.attr('action', window.location.pathname)
  headerSearch.on('submit', e => {
    e.preventDefault()
    let searchInput = $('#searchInput').val()
    // let resultsPage = window.location.pathname.match(/^(\/[a-zA-Z\-\_]+\/)/ig)
    let resultsPage = '/search/'
    window.location.href = window.location.origin + resultsPage + searchInput
  });
});
